// removed by extract-text-webpack-plugin
module.exports = {"guideDetailEditor":"oOYV9","guideDetailEditorTextarea":"_2K-XC _17S31 _2hwsw _2z9kb A5BYb"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/GuideDetailEditor.css
// module id = 1161
// module chunks = 3